import { createSlice } from "@reduxjs/toolkit";
import getDiscountRequestsApi from "@custom/rtk-apis/billing/discountNotification/getDiscountRequests";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const getDiscountRequestsSlice = createSlice({
  name: "getDiscountRequestsSlice",
  initialState,
  reducers: {
    resetGetDiscountSlice (state:any) {
      state.status = "";
      state.result = null;
      state.msg = "";
      state.loading = false;
      state.error = "";
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDiscountRequestsApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getDiscountRequestsApi.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload?.status;
        state.result = payload?.data;
        state.msg = payload?.msg;
      })
      .addCase(getDiscountRequestsApi.rejected, (state, { payload }) => {
        state.loading = false;
        state.msg =  payload?.msg || 'An unexpected error occurred.';
      });
  },
});

export default getDiscountRequestsSlice.reducer;
export const { resetGetDiscountSlice } = getDiscountRequestsSlice.actions;
